export default {
      id: "beta-usage",
      viewBox: "0 0 36 16",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#beta",
      toString: function () {
        return this.url;
      }
    }